import { useState } from 'react';
import Search from 'src/components/Search';
import SelectField from 'src/components/SelectField';

export type PickerOption = { label: string; value: string };

type Props = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: PickerOption[] | undefined;
  isLoading: boolean;
  onSearch: (search: string) => void;
  error?: string;
};

/**
 * Search box + single select. The list is filtered server-side by the search text,
 * so it stays usable with hundreds of providers/students.
 */
const EntityPicker = ({ label, value, onChange, options, isLoading, onSearch, error }: Props) => {
  const [search, setSearch] = useState('');
  const selected = options?.find((o) => o.value === value);
  // Keep the current selection visible even when the search no longer matches it.
  const allOptions =
    value && !selected ? [{ label: 'Selected', value }, ...(options ?? [])] : options ?? [];

  return (
    <div className="flex flex-col gap-2">
      <Search
        size="md"
        value={search}
        placeholder={`Search ${label.toLowerCase()}`}
        onChange={(e) => {
          setSearch(e.target.value);
          onSearch(e.target.value);
        }}
        className="h-12 w-full rounded-lg border-0 bg-neutral-white shadow-elevation-1"
      />
      <SelectField
        label={label}
        placeholder={isLoading ? 'Loading…' : `Pick a ${label.toLowerCase()}`}
        value={value}
        onValueChange={onChange}
        options={allOptions}
        error={error}
      />
    </div>
  );
};

export default EntityPicker;
